/*
 * Copyright Huesik (c) 2019.
 */



const getter = {
  getBoundsDistance: state => {
    return state.MAPS.BOUND_DISTANCE
  },
  getMapCenter: state => {
    return {
      latitude: state.MAPS.CENTER.LATITUDE,
      longitude: state.MAPS.CENTER.LONGITUDE
    }
  },
  getSearchKosiwonList: state => {
    return state.SEARCH.KOSIWON_LIST
  },
  getHoverKosiwon: state => {
    return state.SEARCH.HOVER_KOSIWON
  },
  getMoneyRange: state => {
    return state.FILTERS.MONEY_RANGE
  },
  getUseSexType: state => {
    return state.FILTERS.USE_SEX_TYPE
  },
  getAccessToken: state => {
    return state.USERS.ACCESS_TOKEN
  },
  getRefreshToken: state => {
    return state.USERS.REFRESH_TOKEN
  },
  getLastViewList: state => {
    return state.INTEREST.LAST_VIEW_LIST
  },
  getPickList: state => {
    return state.INTEREST.PICK_LIST
  },
  getBounds: state => {
    return state.MAPS.BOUNDS
  }
}

export default getter
